<template>
  <div class="promoter-list" ref="container">
    <div class="header">
      <div class="promoterHeader bg-color-red">
        <div class="headerCon acea-row row-between-wrapper">
          <div>
            <div class="name">推广人数</div>
            <div>
              <span class="num">{{ first + second }}</span
              >人
            </div>
          </div>
          <div class="iconfont icon-tuandui"></div>
        </div>
      </div>
      <div class="nav acea-row row-around">
        <div
          class="item"
          :class="screen.grade == 0 ? 'on' : ''"
          @click="checkGrade(0)"
        >
          一级({{ first }})
        </div>
        <div
          class="item"
          :class="screen.grade == 1 ? 'on' : ''"
          @click="checkGrade(1)"
        >
          二级({{ second }})
        </div>
      </div>
      <div class="search acea-row row-between-wrapper">
        <form @submit.prevent="submitForm">
          <div class="input">
            <input
              placeholder="点击搜索会员名称"
              v-model="screen.param.keyword"
            />
            <span class="iconfont icon-guanbi"></span>
          </div>
        </form>
        <div class="iconfont icon-sousuo2"></div>
      </div>
    </div>
    <div class="list">
      <div
        class="sortNav acea-row row-middle"
        :class="fixedState === true ? 'on' : ''"
      >
        <div class="sortItem" @click="sort('earnings')">
          团队排序
          <img src="@assets/images/sort1.png" v-if="earnings == 1" />
          <img src="@assets/images/sort2.png" v-if="earnings == 2" />
          <img src="@assets/images/sort3.png" v-if="earnings == 3" />
        </div>
        <div class="sortItem" @click="sort('totalCommission')">
          金额排序
          <img src="@assets/images/sort1.png" v-if="totalCommission == 1" />
          <img src="@assets/images/sort2.png" v-if="totalCommission == 2" />
          <img src="@assets/images/sort3.png" v-if="totalCommission == 3" />
        </div>
        <div class="sortItem" @click="sort('orderSum')">
          订单排序
          <img src="@assets/images/sort1.png" v-if="orderSum == 1" />
          <img src="@assets/images/sort2.png" v-if="orderSum == 2" />
          <img src="@assets/images/sort3.png" v-if="orderSum == 3" />
        </div>
      </div>
      <div :class="fixedState === true ? 'sortList' : ''">
        <div
          class="item acea-row row-between-wrapper"
          v-for="(val, index) in spreadList"
          :key="index"
        >
          <div class="picTxt acea-row row-between-wrapper">
            <div class="pictrue"><img :src="val.avatar" /></div>
            <div class="text">
              <div class="name line1">{{ val.nickname }}</div>
              <div>加入时间: {{ fromatDate(val.created) }}</div>
            </div>
          </div>
          <div class="right">
            <div>
              <span class="font-color-red">{{ val.earnings }}</span> 人
            </div>
            <div>{{ val.orderSum }} 单</div>
            <div>{{ val.totalCommission ? val.totalCommission : 0 }} 元</div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getSpreadUser } from "../../../api/user";
import Loading from "@components/Loading";
import dayjs from "dayjs";
export default {
  name: "PromoterList",
  components: {
    Loading,
  },
  props: {},
  data: function () {
    return {
      fixedState: false,
      screen: {
        pageNo: 1,
        pageSize: 15,
        param: {
          grade: 0,
          keyword: "",
          sort: "",
          first: "",
          second: "",
        },
      },
      earnings: 2,
      totalCommission: 2,
      orderSum: 2,
      loaded: false,
      loading: false,
      spreadList: [],
      loadTitle: "",
    };
  },
  mounted: function () {
    this.getSpreadUsers();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getSpreadUsers();
    });
  },
  watch: {
    "screen.param.sort": function () {
      this.screen.pageNo = 0;
      this.loaded = false;
      this.loading = false;
      this.spreadList = [];
      this.getSpreadUsers();
    },
  },
  methods: {
    handleScroll: function () {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var offsetTop = document.querySelector(".header").clientHeight;
      if (scrollTop >= offsetTop) {
        this.fixedState = true;
      } else {
        this.fixedState = false;
      }
    },
    fromatDate(time) {
      var times = time * 1000;
      return dayjs(times).format("YYYY-MM-DD");
    },
    submitForm: function () {
      this.screen.pageNo = 0;
      this.loaded = false;
      this.loading = false;
      this.spreadList = [];
      this.getSpreadUsers();
    },
    getSpreadUsers: function () {
      let that = this,
        screen = that.screen;
      if (that.loaded || that.loading) return;
      that.loading = true;
      getSpreadUser(screen).then(
        (res) => {
          that.loading = false;
          that.spreadList.push.apply(that.spreadList, res.result.records);
          that.loaded = res.result.records.length < that.screen.pageSize; //判断所有数据是否加载完成；
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.screen.pageNo = that.screen.pageNo + 1;
          that.first = res.result.param.first;
          that.second = res.result.param.second;
        },
        (error) => {
          that.$dialog.message(error.msg);
        },
        300
      );
    },
    checkGrade: function (val) {
      if (val == this.screen.param.grade) return;
      else {
        this.screen.pageNo = 1;
        this.screen.param.grade = val;
        this.loading = false;
        this.loaded = false;
        this.spreadList = [];
        this.getSpreadUsers();
      }
    },
    sort: function (types) {
      let that = this;
      switch (types) {
        case "earnings":
          if (that.earnings == 2) {
            that.earnings = 1;
            that.orderSum = 2;
            that.totalCommission = 2;
            that.screen.param.sort = "earnings DESC";
          } else if (that.earnings == 1) {
            that.earnings = 3;
            that.orderSum = 2;
            that.totalCommission = 2;
            that.screen.param.sort = "earnings ASC";
          } else if (that.earnings == 3) {
            that.earnings = 2;
            that.orderSum = 2;
            that.totalCommission = 2;
            that.screen.param.sort = "";
          }
          break;
        case "totalCommission":
          if (that.totalCommission == 2) {
            that.totalCommission = 1;
            that.orderSum = 2;
            that.earnings = 2;
            that.screen.param.sort = "totalCommission DESC";
          } else if (that.totalCommission == 1) {
            that.totalCommission = 3;
            that.orderSum = 2;
            that.earnings = 2;
            that.screen.param.sort = "totalCommission ASC";
          } else if (that.totalCommission == 3) {
            that.totalCommission = 2;
            that.orderSum = 2;
            that.earnings = 2;
            that.screen.param.sort = "";
          }
          break;
        case "orderSum":
          if (that.orderSum == 2) {
            that.orderSum = 1;
            that.totalCommission = 2;
            that.earnings = 2;
            that.screen.param.sort = "orderSum DESC";
          } else if (that.orderSum == 1) {
            that.orderSum = 3;
            that.totalCommission = 2;
            that.earnings = 2;
            that.screen.param.sort = "orderSum ASC";
          } else if (that.orderSum == 3) {
            that.orderSum = 2;
            that.totalCommission = 2;
            that.earnings = 2;
            that.screen.param.sort = "";
          }
          break;
        default:
          that.screen.param.sort = "";
      }
    },
  },
};
</script>
